import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import 'semantic-ui-css/semantic.min.css';
import './stylesheets/main.css';
import 'animate.css/animate.css';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();
